<div class="each-page">
    <!-- Page Header -->
    <div class="page-header">
        <div class="page-header__content">
            <div class="page-left gap-2.5">
                <div class="page-icon">
                    <img
                        src="../assets/img/dashboard.svg"
                        class="h-8"
                        alt="Add category"
                    />
                </div>

                <div class="page-headings">
                    <h1>{{ pageTitle }}</h1>

                    <p *ngIf="pageSubtitle">
                        {{ pageSubtitle }}
                    </p>
                </div>
            </div>
        </div>

        <div class="page-header-right"></div>
    </div>

    <!-- Page Content -->
    <div class="page-content">
        <section class="course-table-card">
            <div class="create-page">
                <form
                    class="create-page__form"
                 
                    (ngSubmit)="submitCategory()"
                    novalidate
                >
                    <div class="create-page__category-grid">
                        <!-- Name -->
                        <div class="create-page__group">
                            <label for="categoryName">
                                Name
                                <span class="create-page__required">*</span>
                            </label>

                            <div
                                class="create-page__control"
                                [class.create-page__control--invalid]="
                                    isSubmitted &&
                                    nameControl.invalid
                                "
                            >
                                <span class="create-page__control-icon">
                                    <svg
                                        viewBox="0 0 24 24"
                                        aria-hidden="true"
                                    >
                                        <path d="M5 6h14"></path>
                                        <path d="M12 6v12"></path>
                                        <path d="M8 18h8"></path>
                                    </svg>
                                </span>

                                <input
                                    id="categoryName"
                                    type="text"
                                    formControlName="name"
                                    placeholder="Enter category name"
                                    autocomplete="off"
                                />
                            </div>

                            <p
                                class="create-page__error"
                                *ngIf="
                                    isSubmitted &&
                                    nameControl.hasError('required')
                                "
                            >
                                Category name is required.
                            </p>

                            <p
                                class="create-page__error"
                                *ngIf="
                                    isSubmitted &&
                                    nameControl.hasError('maxlength')
                                "
                            >
                                Category name cannot exceed
                                100 characters.
                            </p>
                        </div>

                        <!-- Feature -->
                         <div class="create-page__group">
    <label>Feature</label>

    <div
        class="category-feature-selector"
        role="group"
        aria-label="Featured category"
    >
        <button
            type="button"
            class="category-feature-option"
            [class.category-feature-option--selected]="
                featuredControl.value === true
            "
            [attr.aria-pressed]="
                featuredControl.value === true
            "
            (click)="setFeatured(true)"
        >
            <span
                class="category-feature-option__indicator"
            >
                <svg
                    *ngIf="featuredControl.value === true"
                    viewBox="0 0 20 20"
                    aria-hidden="true"
                >
                    <path
                        d="M4.5 10L8.2 13.5L15.5 6.5"
                    ></path>
                </svg>
            </span>

            <span>Yes</span>
        </button>

        <button
            type="button"
            class="category-feature-option"
            [class.category-feature-option--selected]="
                featuredControl.value === false
            "
            [attr.aria-pressed]="
                featuredControl.value === false
            "
            (click)="setFeatured(false)"
        >
            <span
                class="category-feature-option__indicator"
            >
                <svg
                    *ngIf="featuredControl.value === false"
                    viewBox="0 0 20 20"
                    aria-hidden="true"
                >
                    <path
                        d="M4.5 10L8.2 13.5L15.5 6.5"
                    ></path>
                </svg>
            </span>

            <span>No</span>
        </button>
    </div>
</div>

                        <!-- Category Image -->
                        <div class="create-page__group">
                            <label>
                                Image
                                <span class="create-page__required">*</span>
                            </label>

                            <div class="category-image-upload">
                                <button
                                    type="button"
                                    class="category-image-upload__preview"
                                    [class.category-image-upload__preview--invalid]="
                                        categoryImageError
                                    "
                                    (click)="
                                        categoryImageInput.click()
                                    "
                                    aria-label="Upload category image"
                                >
                                    <ng-container
                                        *ngIf="
                                            categoryImagePreview;
                                            else categoryUploadPlaceholder
                                        "
                                    >
                                        <img
                                            [src]="
                                                categoryImagePreview
                                            "
                                            alt="Category image preview"
                                        />

                                        <span
                                            class="category-image-upload__overlay"
                                        >
                                            <svg
                                                viewBox="0 0 24 24"
                                                aria-hidden="true"
                                            >
                                                <path
                                                    d="M12 16V4"
                                                ></path>
                                                <path
                                                    d="m7 9 5-5 5 5"
                                                ></path>
                                                <path
                                                    d="M5 14v5h14v-5"
                                                ></path>
                                            </svg>

                                            <span>
                                                Change Image
                                            </span>
                                        </span>
                                    </ng-container>

                                    <ng-template
                                        #categoryUploadPlaceholder
                                    >
                                        <span
                                            class="category-image-upload__placeholder"
                                        >
                                            <span
                                                class="category-image-upload__icon"
                                            >
                                                <svg
                                                    viewBox="0 0 24 24"
                                                    aria-hidden="true"
                                                >
                                                    <path
                                                        d="M12 16V4"
                                                    ></path>
                                                    <path
                                                        d="m7 9 5-5 5 5"
                                                    ></path>
                                                    <path
                                                        d="M5 14v5h14v-5"
                                                    ></path>
                                                </svg>
                                            </span>

                                            <strong>
                                                Upload category image
                                            </strong>

                                            <span>
                                                PNG only • Recommended
                                                60 × 60 • Max 1 MB
                                            </span>
                                        </span>
                                    </ng-template>
                                </button>

                                <input
                                    #categoryImageInput
                                    type="file"
                                    class="category-image-upload__input"
                                    accept=".png,image/png"
                                    (change)="
                                        onCategoryImageSelected(
                                            $event
                                        )
                                    "
                                />

                                <p
                                    class="category-image-upload__error"
                                    *ngIf="categoryImageError"
                                >
                                    {{ categoryImageError }}
                                </p>
                            </div>
                        </div>

                        <!-- Meta Title -->
                        <div class="create-page__group">
                            <label for="metaTitle">
                                Meta Title
                            </label>

                            <div
                                class="create-page__control"
                                [class.create-page__control--invalid]="
                                    isSubmitted &&
                                    metaTitleControl.invalid
                                "
                            >
                                <span class="create-page__control-icon">
                                    <svg
                                        viewBox="0 0 24 24"
                                        aria-hidden="true"
                                    >
                                        <path d="M5 6h14"></path>
                                        <path d="M12 6v12"></path>
                                        <path d="M8 18h8"></path>
                                    </svg>
                                </span>

                                <input
                                    id="metaTitle"
                                    type="text"
                                    formControlName="metaTitle"
                                    placeholder="Enter meta title"
                                    autocomplete="off"
                                />
                            </div>

                            <p
                                class="create-page__error"
                                *ngIf="
                                    isSubmitted &&
                                    metaTitleControl.hasError(
                                        'maxlength'
                                    )
                                "
                            >
                                Meta title cannot exceed
                                100 characters.
                            </p>
                        </div>

                        <!-- OG Image -->
                        <div class="create-page__group">
                            <label>
                                OG Image
                            </label>

                            <div class="category-image-upload">
                                <button
                                    type="button"
                                    class="category-image-upload__preview"
                                    [class.category-image-upload__preview--invalid]="
                                        ogImageError
                                    "
                                    (click)="ogImageInput.click()"
                                    aria-label="Upload OG image"
                                >
                                    <ng-container
                                        *ngIf="
                                            ogImagePreview;
                                            else ogUploadPlaceholder
                                        "
                                    >
                                        <img
                                            [src]="ogImagePreview"
                                            alt="OG image preview"
                                        />

                                        <span
                                            class="category-image-upload__overlay"
                                        >
                                            <svg
                                                viewBox="0 0 24 24"
                                                aria-hidden="true"
                                            >
                                                <path
                                                    d="M12 16V4"
                                                ></path>
                                                <path
                                                    d="m7 9 5-5 5 5"
                                                ></path>
                                                <path
                                                    d="M5 14v5h14v-5"
                                                ></path>
                                            </svg>

                                            <span>
                                                Change Image
                                            </span>
                                        </span>
                                    </ng-container>

                                    <ng-template
                                        #ogUploadPlaceholder
                                    >
                                        <span
                                            class="category-image-upload__placeholder"
                                        >
                                            <span
                                                class="category-image-upload__icon"
                                            >
                                                <svg
                                                    viewBox="0 0 24 24"
                                                    aria-hidden="true"
                                                >
                                                    <path
                                                        d="M12 16V4"
                                                    ></path>
                                                    <path
                                                        d="m7 9 5-5 5 5"
                                                    ></path>
                                                    <path
                                                        d="M5 14v5h14v-5"
                                                    ></path>
                                                </svg>
                                            </span>

                                            <strong>
                                                Upload OG image
                                            </strong>

                                            <span>
                                                PNG or JPG • Recommended
                                                1200 × 627
                                            </span>
                                        </span>
                                    </ng-template>
                                </button>

                                <input
                                    #ogImageInput
                                    type="file"
                                    class="category-image-upload__input"
                                    accept=".jpeg,.jpg,.png,image/jpeg,image/png"
                                    (change)="
                                        onOgImageSelected($event)
                                    "
                                />

                                <p
                                    class="category-image-upload__error"
                                    *ngIf="ogImageError"
                                >
                                    {{ ogImageError }}
                                </p>
                            </div>
                        </div>

                        <!-- Meta Information -->
                        <div class="create-page__meta-fields">
                            <!-- Meta Description -->
                            <div class="create-page__group">
                                <label for="metaDescription">
                                    Meta Description
                                </label>

                                <div
                                    class="create-page__control create-page__control--textarea"
                                    [class.create-page__control--invalid]="
                                        isSubmitted &&
                                        metaDescriptionControl.invalid
                                    "
                                >
                                  

                                    <textarea
                                        id="metaDescription"
                                        formControlName="metaDescription"
                                        placeholder="Enter meta description" class="w-100 form-control"
                                        rows="4"
                                    ></textarea>
                                </div>

                                <p
                                    class="create-page__error"
                                    *ngIf="
                                        isSubmitted &&
                                        metaDescriptionControl.hasError(
                                            'maxlength'
                                        )
                                    "
                                >
                                    Meta description cannot
                                    exceed 300 characters.
                                </p>
                            </div>

                            <!-- Meta Keywords -->
                            <div class="create-page__group">
                                <label for="metaKeywords">
                                    Meta Keywords
                                </label>

                                <div
                                    class="create-page__control"
                                    [class.create-page__control--invalid]="
                                        isSubmitted &&
                                        metaKeywordsControl.invalid
                                    "
                                >
                                    <span
                                        class="create-page__control-icon"
                                    >
                                        <svg
                                            viewBox="0 0 24 24"
                                            aria-hidden="true"
                                        >
                                            <path d="M5 6h14"></path>
                                            <path d="M12 6v12"></path>
                                            <path d="M8 18h8"></path>
                                        </svg>
                                    </span>

                                    <input
                                        id="metaKeywords"
                                        type="text"
                                        formControlName="metaKeywords"
                                        placeholder="Enter meta keywords"
                                        autocomplete="off"
                                    />
                                </div>

                                <p
                                    class="create-page__error"
                                    *ngIf="
                                        isSubmitted &&
                                        metaKeywordsControl.hasError(
                                            'maxlength'
                                        )
                                    "
                                >
                                    Meta keywords cannot exceed
                                    250 characters.
                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- Actions -->
                    <div
                        class="create-page__actions category-form-actions"
                    >
                        <button
                            type="button"
                            class="create-page__button create-page__button--additional"
                            [disabled]="isSaving"
                            (click)="saveAndAddAnother()"
                        >
                            <i
                                class="fa fa-plus-circle"
                                aria-hidden="true"
                            ></i>

                            <span>
                                Save & Add Another
                            </span>
                        </button>

                        <div class="category-form-actions__right">
                            <button
                                type="button"
                                class="create-page__button create-page__button--secondary"
                                [disabled]="isSaving"
                                (click)="cancel()"
                            >
                                <i
                                    class="fa fa-times-circle"
                                    aria-hidden="true"
                                ></i>

                                <span>Cancel</span>
                            </button>

                            <button
                                type="submit"
                                class="create-page__button create-page__button--primary"
                                [disabled]="isSaving"
                            >
                                <span
                                    class="create-page__spinner"
                                    *ngIf="isSaving"
                                    aria-hidden="true"
                                ></span>

                                <svg
                                    *ngIf="!isSaving"
                                    viewBox="0 0 24 24"
                                    aria-hidden="true"
                                >
                                    <path
                                        d="M4 4h13l3 3v13H4Z"
                                    ></path>
                                    <path
                                        d="M8 4v6h8V4"
                                    ></path>
                                </svg>

                                <span>
                                    {{
                                        isSaving
                                            ? 'Saving...'
                                            : 'Save'
                                    }}
                                </span>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </section>
    </div>
</div>